export const SignInData = [
  {
    id: 'email',
    name: 'userEmail',
    placeholder: '이메일(ID)',
    type: 'text',
    message: { email: '이메일 형식에 맞지 않습니다.' },
  },
  {
    id: 'password',
    name: 'userPassword',
    placeholder: '비밀번호',
    type: 'password',
    message: { password: '대소문자, 특수문자, 숫자 1자이상 포함해야됩니다.' },
  },
];
